var React = require('react');

function MenuHamburger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 4.5C3 4.22386 3.22386 4 3.5 4H14.5C14.7761 4 15 4.22386 15 4.5V5.5C15 5.77614 14.7761 6 14.5 6H3.5C3.22386 6 3 5.77614 3 5.5V4.5Z","fill":"white","key":0}),React.createElement("path",{"d":"M3 8.5C3 8.22386 3.22386 8 3.5 8H14.5C14.7761 8 15 8.22386 15 8.5V9.5C15 9.77614 14.7761 10 14.5 10H3.5C3.22386 10 3 9.77614 3 9.5V8.5Z","fill":"white","key":1}),React.createElement("path",{"d":"M3.5 12C3.22386 12 3 12.2239 3 12.5V13.5C3 13.7761 3.22386 14 3.5 14H14.5C14.7761 14 15 13.7761 15 13.5V12.5C15 12.2239 14.7761 12 14.5 12H3.5Z","fill":"white","key":2})]);
}

MenuHamburger.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = MenuHamburger;

MenuHamburger.default = MenuHamburger;
